<template>
  <div
    :style="[wh]"
    class="lunbo"
    v-touchstart="start"
    v-touchend="end"
    v-swipeleft="swipeleft"
    v-swiperight="swiperight"
  >
    <ul ref="lbul" name="show" :style="{width:pwidth*len+'px',height:pheight+'px'}">
      <li v-for="(item,key) in lilist" :key="key" :id="key" :style="[wh]">
        <a :href="item.href" :target="item.target">
          <div
            v-html="item.infodom"
            :style="{width:pwidth+'px',height:pheight+'px',backgroundImage:'url('+item.src+')', backgroundSize:''+wh.width+' '+wh.height+''}"
          ></div>
        </a>
      </li>
    </ul>
    <ol ref="lbol" v-if="ishavePoint" class="pointlist">
      <li
        v-for="(item,key) in templist"
        :key="key"
        :rel="key"
        :style="ollistyle"
        @click="pointClick($event)"
      ></li>
    </ol>
    <div v-if="ishaveArrow" class="pointleft" @click="clickleft" :style="leftstyle">
      <div class="pointArrow left"></div>
    </div>
    <div v-if="ishaveArrow" class="pointright" @click="clickright" :style="rightstyle">
      <div class="pointArrow"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      templist: [],
      lilist: this.list,
      len: 0,
      index: 0,
      pointindex: 0,
      pwidth: 0,
      pheight: 0,
      wh: {
        width: 0,
        height: 0
      },
      ul: null,
      ol: null,
      li: null,
      olwidth: 0,
      timer: {
        set(val) {
          this.$store.state.timeout = val;
        },
        get() {
          return this.$store.state.timeout;
        }
      },
      data: {},
      ap: this.nogap ? this.autoplay : false,
      obj: null
    };
  },
  props: {
    // 数据源
    list: {
      type: Array,
      default: () => []
    },
    // 父框宽度
    width: {
      type: Number,
      default: 100
    },
    // 父框高度
    height: {
      type: Number,
      default: 100
    },
    // 运动速率
    loop: {
      type: Number,
      default: 5000
    },
    // 运动模式
    effect: {
      type: String,
      default: "left"
    },
    // 是否自动轮播
    autoplay: {
      type: Boolean,
      default: true
    },
    // 是否无缝滚动
    nogap: {
      type: Boolean,
      default: true
    },
    // 是否有箭头
    ishaveArrow: {
      type: Boolean,
      default: true
    },
    // 是否有小点
    ishavePoint: {
      type: Boolean,
      default: true
    },
    // 箭头左 样式
    leftstyle: {},
    // 箭头右 样式
    rightstyle: {},
    // 小点样式
    ollistyle: {},
    // 小点选中样式
    activeBgColor: {
      type: String,
      default: "orange"
    }
  },
  methods: {
    // created初始化逻辑
    init() {
      this.pwidth = this.$browser.v.mobile()
        ? this.$method.reMobileNum(this.width)
        : this.width;
      this.pheight = this.$browser.v.mobile()
        ? this.$method.reMobileNum(this.height)
        : this.height;
      this.wh.width = this.pwidth + "px";
      this.wh.height = this.pheight + "px";

      // 是否是无缝滚动模式
      if (this.nogap) {
        this.lilist.push(this.list[0]);
        for (let i = 0; i < this.lilist.length - 1; i++) {
          this.templist[i] = this.lilist[i];
        }
      } else {
        this.templist = this.lilist;
      }
      this.len = this.list.length;
    },
    // 自动轮播逻辑
    atplay() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.index++;
        this.pointindex++;
        if (this.pointindex > this.len - 2) {
          this.pointindex = 0;
        }
        this.todo("autoplay");
      }, this.loop);
    },
    // 主要函数
    todo(type) {
      // 是否是无缝滚动模式
      if (this.nogap) {
        // 是最后一张图片
        if (this.index === this.len) {
          this.ul.style.left = 0 + "px";
          this.index = 1;
        }
        // 如果是第一张
        if (this.index === -1) {
          this.ul.style.left = -1 * (this.len - 1) * this.pwidth + "px";
          this.index = this.len - 2;
        }
      } else {
        // 正常滚动
        this.ap = false;
        if (this.index === -1) {
          this.index = this.pointindex = 0;
        }
        if (this.index === this.len) {
          this.index = this.pointindex = this.len - 1;
        }
      }

      this.pointSoc();
      this.animate(this.index, type);
    },
    start() {},
    // 操作结束启用自动轮播
    end() {
      if (this.ap) {
        this.atplay();
      }
    },
    // 向左业务逻辑
    left(type) {
      this.index++;
      this.pointindex++;
      if (this.index === this.len - 1 && this.nogap) {
        this.pointindex = 0;
      }

      this.todo(type);
    },
    // 向右业务逻辑
    right(type) {
      this.index--;
      this.pointindex--;
      if (this.nogap) {
        if (this.index < 0) {
          this.pointindex = this.len - 2;
        }
        if (this.pointindex < 0) {
          this.pointindex = this.len - 2;
        }
      }

      this.todo(type);
    },
    // 指向标业务逻辑
    pointClick(e) {
      let objolli = e.path[0];
      let olliindex = objolli.getAttribute("rel");
      this.pointindex = olliindex;
      this.index = olliindex;

      this.todo("clickpoint", objolli);
    },
    // 向左按钮
    clickleft() {
      this.right("clickleft");
    },
    // 向右按钮
    clickright() {
      this.left("clickright");
    },
    // 向左滑动
    swipeleft() {
      this.left("swipeleft");
    },
    // 向右滑动
    swiperight() {
      this.right("swiperight");
    },
    // ul>li,ol>li添加访问状态Cur
    pointSoc() {
      // 处理ol>li的访问
      if (this.ishavePoint) {
        this.obj = this.ol.children[this.pointindex];
        this.$addClass(this.obj, "Cur");
        this.$removeClass(this.$siblings(this.obj), "Cur");
        // 如果访问颜色不是默认颜色
        if (this.activeBgColor !== "orange") {
          this.obj.style.backgroundColor = this.activeBgColor;
          for (let i in this.$siblings(this.obj)) {
            this.$siblings(this.obj)[i].style.backgroundColor = "";
          }
        }
      }

      // 处理ul>li的访问
      this.li = this.ul.children[this.pointindex];
      this.$addClass(this.li, "Cur");
      this.$removeClass(this.$siblings(this.li), "Cur");

      // 处理最后一张辅助图
      if (this.pointindex === 0 && this.nogap) {
        this.$addClass(this.ul.children[this.len - 1], "Cur");
      }
    },
    // 运动模式选择
    animate(i, type) {
      switch (this.effect) {
        case "fadeIn":
          // 待补充
          break;
        case "left":
          this.animateleft(i, type);
          break;
        default:
          this.animateleft(i, type);
          break;
      }
    },
    // 左右运动
    animateleft(i, type) {
      let left = -1 * this.pwidth * i;
      this.$animate(this.ul, { left: left }, 16, 0.1, () => {
        // 结束回调
        this.data = { obj: this.li, index: this.pointindex, type: type };
        this.$emit("animateover", this.data);
      });
    }
  },
  mounted() {
    // 构建完毕后业务初始化
    this.ul = this.$refs.lbul;
    this.li = this.ul.children[0];
    this.$addClass(this.li, "Cur");

    if (this.ul.nodeType === 1) {
      // 是否是无缝滚动模式
      if (this.nogap && this.ishavePoint) {
        this.$addClass(this.ul.children[this.len - 1], "Cur");
      }
      // 是否自动轮播
      if (this.ap) {
        this.atplay();
      }
      // 是否带有小标
      if (this.ishavePoint) {
        // 给首个ol>li添加默认Cur状态
        this.ol = this.$refs.lbol;
        this.obj = this.ol.children[0];
        this.$addClass(this.obj, "Cur");
        if (this.activeBgColor !== "orange") {
          this.obj.style.backgroundColor = this.activeBgColor;
        }

        // 处理小标位置
        /* this.olwidth = this.ol.offsetWidth
        this.ol.style.width = this.olwidth + 'px'
        this.ol.style.marginLeft = -1 * this.olwidth / 2 + 'px' */
      }

      /* for (let i in this.list) {
        if (this.list[i].infodom !== undefined) {
          console.log(this.list[i].infodom);
        }
      } */

      this.$emit("init", this.ul);
    } else {
      this.$emit("initerror");
    }
  },
  created() {
    this.init();
  },
  // 预防定时器未清除
  beforeDestroy() {
    this.$once("hook:beforeDestroy", () => {
      clearInterval(this.timer);
    });
  }
};
</script>

<style scoped>
.lunbo {
  position: relative;
  overflow: hidden;
}
.lunbo ul {
  position: absolute;
  height: 100%;
}
.lunbo ul li {
  float: left;
}
.lunbo ul li a {
  display: block;
}
.lunbo ul li a img {
  width: 100%;
}
/* 指向标 */
.pointlist {
  position: absolute;
  bottom: 20px;
  left: 50%;
  display: flex;
  transform: translate3d(-50%, 0, 0);
  overflow: hidden;
}
.pointlist li {
  position: relative;
  width: 50px;
  height: 8px;
  margin: 0 5px;
  float: left;
  background-color: #fff;
  cursor: pointer;
}
.pointlist li.Cur {
  background-color: orange;
}
/* 左右按钮 */
.pointleft,
.pointright {
  position: absolute;
  width: 20px;
  height: 60px;
  top: 50%;
  transform: translate3d(0, -50%, 0);
  cursor: pointer;
  overflow: hidden;
}
.pointleft {
  left: 20px;
}
.pointright {
  right: 20px;
}

/* 箭头 */
.pointArrow {
  position: relative;
  width: 100%;
  height: 100%;
  cursor: pointer;
  background-color: black;
  opacity: 0.6;
  overflow: hidden;
}
.pointArrow:before,
.pointArrow:after,
.pointArrow.left:before,
.pointArrow.left:after {
  position: absolute;
  content: "";
  top: 50%;
  left: 50%;
  margin-left: -6px;
  width: 0;
  height: 0;
  display: block;
  border: 12px solid transparent;
  border-left-color: #fff;
  transform: translate3d(0, -50%, 0);
}
.pointArrow.left:before,
.pointArrow.left:after {
  left: 50%;
  margin-left: -18px;
  border: 12px solid transparent;
  border-right-color: #fff;
}
.pointArrow:after {
  left: 50%;
  margin-left: -8px;
  border-left-color: black;
}
.pointArrow.left:after {
  left: 50%;
  margin-left: -16px;
  border-right-color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Lunbo.vue